var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { staticClass: "user-details", attrs: { id: "userDetails" } },
    [
      _c("div", { staticClass: "navBar" }, [
        _c("img", {
          staticClass: "logo",
          attrs: {
            src: _vm.darkMode
              ? _vm.brandingService.getLoginDarkLogoUrl()
              : _vm.brandingService.getLoginLogoUrl(),
            alt: "brandingService.getLoginLogoAlt()",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "header-container" }, [
          _c("div", { staticClass: "pageTitle" }, [_vm._v("User Profile")]),
          _vm._v(" "),
          _c("div", { staticClass: "headerTab overviewTab" }, [
            _vm._v("Overview"),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "helpButton",
            attrs: {
              href: _vm.brandingService.getSupportUrl("userDetails"),
              target: "_blank",
            },
          },
          [_c("i", { staticClass: "fal fa-question-circle" })]
        ),
      ]),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "sidebar-container",
          attrs: { app: "", clipped: "", permanent: "" },
        },
        [_c("user-details-sidebar", { attrs: { userData: _vm.sidebarData } })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "user-details-main-container" }, [
        _c(
          "div",
          { staticClass: "user-details-grid-container" },
          [
            _c("user-details-grid", {
              attrs: {
                "user-email": _vm.userEmail,
                "date-range": _vm.dateRange,
                licenses: _vm.licenseData,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "user-details-footer",
            attrs: { href: "http://www.vyopta.com", target: "_blank" },
          },
          [
            _vm._v(
              "\n      © " + _vm._s(_vm.currentYear) + " HP Inc.\n       "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.hp.com/us-en/privacy/privacy-central.html",
                  target: "_blank",
                },
              },
              [_vm._v("Privacy Statement")]
            ),
            _vm._v(",\n      "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://support.hp.com/us-en/document/ish_12775809-12775790-16",
                  target: "_blank",
                },
              },
              [_vm._v("EULA")]
            ),
            _vm._v(",\n      and "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.hp.com/content/dam/sites/worldwide/privacy/pdf/master-level/PARTNER-DPA-202109.pdf",
                  target: "_blank",
                },
              },
              [_vm._v("DPA")]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }